var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriggerImage2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#E0E6F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6895_19630",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6895_19630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 28.5C16.95 28.5 16.0625 28.1375 15.3375 27.4125C14.6125 26.6875 14.25 25.8 14.25 24.75C14.25 23.8833 14.5083 23.1208 15.025 22.4625C15.5417 21.8042 16.2 21.3583 17 21.125V19H11V15H8.5V8H15.5V15H13V17H23V14.875C22.2 14.6417 21.5417 14.1958 21.025 13.5375C20.5083 12.8792 20.25 12.1167 20.25 11.25C20.25 10.2 20.6125 9.3125 21.3375 8.5875C22.0625 7.8625 22.95 7.5 24 7.5C25.05 7.5 25.9375 7.8625 26.6625 8.5875C27.3875 9.3125 27.75 10.2 27.75 11.25C27.75 12.1167 27.4917 12.8792 26.975 13.5375C26.4583 14.1958 25.8 14.6417 25 14.875V19H19V21.125C19.8 21.3583 20.4583 21.8042 20.975 22.4625C21.4917 23.1208 21.75 23.8833 21.75 24.75C21.75 25.8 21.3875 26.6875 20.6625 27.4125C19.9375 28.1375 19.05 28.5 18 28.5ZM24 13C24.4833 13 24.8958 12.8292 25.2375 12.4875C25.5792 12.1458 25.75 11.7333 25.75 11.25C25.75 10.7667 25.5792 10.3542 25.2375 10.0125C24.8958 9.67083 24.4833 9.5 24 9.5C23.5167 9.5 23.1042 9.67083 22.7625 10.0125C22.4208 10.3542 22.25 10.7667 22.25 11.25C22.25 11.7333 22.4208 12.1458 22.7625 12.4875C23.1042 12.8292 23.5167 13 24 13ZM10.5 13H13.5V10H10.5V13ZM18 26.5C18.4833 26.5 18.8958 26.3292 19.2375 25.9875C19.5792 25.6458 19.75 25.2333 19.75 24.75C19.75 24.2667 19.5792 23.8542 19.2375 23.5125C18.8958 23.1708 18.4833 23 18 23C17.5167 23 17.1042 23.1708 16.7625 23.5125C16.4208 23.8542 16.25 24.2667 16.25 24.75C16.25 25.2333 16.4208 25.6458 16.7625 25.9875C17.1042 26.3292 17.5167 26.5 18 26.5Z",
    fill: "#EF7707"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerImage2);
export default __webpack_public_path__ + "static/media/triggerImage2.523ddc80b0dbd58f7be474dca064bc4d.svg";
export { ForwardRef as ReactComponent };